import { Footer } from '@almbrand/footer';
import { TrackingEvent } from '@almbrand/trackinghooks';

export const FooterComponent: React.FC<FooterReference> = ({
	linkColumns,
	policyLinks,
	companyAddress,
	companyCity,
	companyName,
	legalInfo,
	legalInfoSecondLine,
	companyVatNumber,
	logoImage,
	logoUrl,
}) => {
	const rootUrl = window.location.origin;

	const footerLinks = linkColumns.map((linkColumn) => ({
		header: linkColumn.header,
		links: linkColumn.links.map((link) => ({
			text: link.text,
			url: link.url,
			target: link.target,

			trackingEvent: {
				event: 'trackNavigation',
				navigationAction: link?.text ?? '',
				navigationDestination: `${rootUrl}${link?.url ?? ''}`,
				navigationType: 'footer',
			} as TrackingEvent,
		})),
	}));

	const getLegalInfo = () => {
		return (
			<>
				{legalInfo && <div>{legalInfo}</div>}
				{legalInfoSecondLine && <div>{legalInfoSecondLine}</div>}
			</>
		);
	};

	return (
		<Footer
			companyInfo={{
				name: companyName,
				address: companyAddress,
				city: companyCity,
				legalInfo: getLegalInfo(),
				cvr: companyVatNumber,
			}}
			linkColumns={footerLinks}
			policyLinks={policyLinks.map((link) => ({ text: link.text, url: link.url }))}
			logo={logoImage?.url}
			logoUrl={logoUrl?.url}
		/>
	);
};
